import { useEffect, useState } from 'react';
import { VaultAccountPayoutFrequencySetAuditEntry } from '../types';
import { getPayoutFrequencySetLogs } from '../../../services/vault/auditLogs';

export default function usePayoutFrequencySetLogs({
  orgId,
}: {
  orgId: string;
}): { logs: VaultAccountPayoutFrequencySetAuditEntry[]; isLoading: boolean } {
  const [logs, setLogs] = useState<VaultAccountPayoutFrequencySetAuditEntry[]>(
    [],
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function gatherData(): Promise<void> {
      if (!isLoading) {
        return;
      }
      const retrievedLogs = await getPayoutFrequencySetLogs(orgId);
      setLogs(retrievedLogs);
      setIsLoading(false);
    }
    gatherData();
  });
  return { logs, isLoading };
}
